import React from 'react';
import useProjectIdContext from '../../Contexts/ProjectContexts/ProjectIdContext/useProjectIdContext';
import useMultiLanguageContext from '../MultiLanguageContext/useMultiLanguageContext';
import { isApplicationSyncedMessage, isApplicationUnsyncedMessage, isSyncStateUpdateMessage } from '../NewSessionContext/WebsocketConnectionProviders/WebsocketApiConnectionContext/types';
import useWebsocketApiConnectionContext from '../NewSessionContext/WebsocketConnectionProviders/WebsocketApiConnectionContext/useWebsocketApiConnectionContext';
import useSessionContext from '../SessionContextProvider/useSessionContext';
import { useApplicationSyncContext } from './useApplicationSyncContext';

export default function ApplicationSyncContextUpdater({ children }: { children: React.ReactNode }) {
  const { isSynced, setIsSynced } = useApplicationSyncContext();
  const { projectId } = useProjectIdContext();
  const { language } = useMultiLanguageContext();
  const { session, context } = useSessionContext();
  const { sendJsonMessage, lastJsonMessage } = useWebsocketApiConnectionContext();

  React.useEffect(() => {
    if (isApplicationSyncedMessage(lastJsonMessage)) {
      setIsSynced(true);
    }

    if (isApplicationUnsyncedMessage(lastJsonMessage)) {
      setIsSynced(false);
    }

    if (isSyncStateUpdateMessage(lastJsonMessage)) {
      sendJsonMessage({ type: 'SyncStateUpdate', payload: { projectId, language } });
    }
  }, [lastJsonMessage]);

  React.useEffect(() => {
    if (isSynced) {
      sendJsonMessage({
        type: 'SyncStateUpdate',
        message: null,
        payload: {
          projectId,
          ...language && { language },
        },
      });
    }
  }, [isSynced, projectId, language]);

  React.useEffect(() => {
    if (isSynced) {
      sendJsonMessage({
        type: 'SyncStateUpdate',
        message: null,
        payload: {
          session: !session ? null : {
            id: session.id, projectId: session.projectId, externalCallId: session.externalCallId,
          },
        },
      });
    }
  }, [isSynced, session]);

  React.useEffect(() => {
    if (isSynced) {
      sendJsonMessage({
        type: 'SyncStateUpdate',
        message: null,
        payload: {
          context,
        },
      });
    }
  }, [isSynced, context]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
